// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"breadcrumbs_breadcrumbs__d-tH5","breadcrumbLink":"breadcrumbs_breadcrumbLink__C4IQF","breadcrumbLast":"breadcrumbs_breadcrumbLast__776WL"};